import ChartAxisLabel from './ChartAxisLabel'

export default ChartAxisLabel



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/ChartAxisLabel/index.js